import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'react-decoration';
import i18next from 'i18next';

export default class View extends React.Component {
  static defaultProps = {};

  static propTypes = {
    serialno: PropTypes.number.isRequired,
    checked: PropTypes.bool.isRequired,
    buttonEvent: PropTypes.func.isRequired,
    functionConfig: PropTypes.object,
    data: PropTypes.array.isRequired,
    displayConfig: PropTypes.array.isRequired
  };

  t = (keys, options) => {
    return i18next.translator.translate(keys, options);
  };

  @autobind
  loadBookDefaultImg(e) {
    e.target.src = 'images/bookcover.jpg';
  }
}

View.listType = 'Normal';
